module.exports = __webpack_public_path__ + "static/media/printer.ea173c84.svg";